import debug from 'debug'
import dynamic from 'next/dynamic'
import { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'store'
import { removeTrigger } from 'store/trigger'
import { ID } from 'utils/id'

const logger = debug('components/trigger/listener')

const FeedbackModal = dynamic<{ triggerId: ID }>(() => import('./feedback.modal').then(mod => ({
  default: mod.FeedbackModal,
})))
const IframeModal = dynamic<{ triggerId: ID }>(() => import('./iframe.modal').then(mod => ({
  default: mod.IframeModal,
})))
const RewardModal = dynamic<{ triggerId: ID }>(() => import('./reward.badge.modal').then(mod => ({
  default: mod.RewardModal,
})))

export const TriggerListener: FC = () => {
  const trigger = useAppSelector((state) => state.trigger.ids.length > 0
    ? state.trigger.entities[state.trigger.ids[0]]
    : undefined,
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (trigger && !['feedback', 'iframe', 'reward'].includes(trigger.type)) {
      logger('remove trigger %O', trigger)
      dispatch(removeTrigger(trigger.id))
    }
  }, [trigger?.id])

  if (trigger) {
    logger('render trigger %O', trigger)
  }

  switch (trigger?.type) {
    case 'feedback':
      return <FeedbackModal triggerId={trigger.id} />

    case 'iframe':
      return <IframeModal triggerId={trigger.id} />

    case 'reward':
      return <RewardModal triggerId={trigger.id} />
  }

  return null
}
